module.exports = __webpack_public_path__ + "img/midia-boaforma-1024x1024.0110a74d.png";